import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=1421a6d6&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=ts"
export * from "./Terms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1421a6d6",
  null
  
)

export default component.exports